<div class="circle-progress circle-progress--{{percent > 100 ? '100' : percent}}">
    <div class="circle-progress__content">
        <span>{{ percent }}%</span>
    </div>
</div>
